import './StartWrtingComp.css'
import { useState, useRef } from 'react';

export default function Writeupload() {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [fileCID, setFileCID] = useState('');
// const [selectedBlockchain, setSelectedBlockchain] = useState('');
const [daoname,setdaoname]=useState(null);
const [selectedFile, setSelectedFile] = useState(null);
const [uploadedHash, setUploadedHash] = useState(null);
const formref=useRef(null);
  const handleRadioChange = (event) => {
    // const value = event.target.value;
    // localStorage.setItem('selectedOption', value);
    // setSelectedBlockchain(value);
    // console.log(localStorage.getItem('selectedOption'));
  };
const viewfile=()=>{
window.location.href=`http://localhost:8080/ipfs/${uploadedHash}`;
}
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };
  const handlenameChange = (event) => {
    const dao_name = event.target.value;
    setdaoname(dao_name);
  };

  const uploadFileToIPFS = async () => {
    // Check if a file is selected
    
      if (!selectedFile) {
      // console.error('No file selected');
      alert('Select The File To Upload');
      return;
    }
    if (!daoname) {
      alert('Enter the Name Of Your DAO');
      return;
    }

  
    const formData = new FormData();
    formData.append('file', selectedFile);
   
  
    try {
      const response = await fetch('http://localhost:5001/api/v0/add', {
        method: 'POST',
        body: formData,
      });
  
      if (!response.ok) {
        alert("Your Will Is Not Uploaded,Please Try Again Later...");
        throw new Error('Failed to upload file to IPFS');

      }
  
      const data = await response.json();
      const cid = data.Hash; // Assuming the CID is returned in the "Hash" field
  
      // Handle the response from IPFS
      console.log('File uploaded to IPFS:', data);
      setUploadedHash(cid);
  console.log(daoname);
      // Send data to the PHP script
      // selectedFile.name for selecting the input file name as it is
      const postData = {
        selectedFile: daoname,
        cid: cid,
        walletAddress: localStorage.getItem('address'),
        daoname:daoname,
      };
  
      const phpScriptUrl = 'https://blissregency.com/ipfsfiles.php';
      const phpResponse = await fetch(phpScriptUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        body: JSON.stringify(postData),
      });
  
      if (phpResponse.ok) {
        console.log('Data sent to PHP script successfully');
      } else {
        console.error('Failed to send data to PHP script');
      }
    } catch (error) {
      alert("Your Will Is Not Uploaded,Please Try Again Later...");
      console.error('Failed to upload file to IPFS:', error);
    }
  };
  const cancel_upload=()=>{
    formref.current.reset();
  }
  
  
      
    return (
  <>
        {
           uploadedHash !== null ?(
            <div className='startwritingcard'>
            <h1 className='mb-4'>SUCCESSFULLY SUBMITTED FILE TO IPFS </h1>
            <div className="container">

            <div id='startWritingForm'>
            <div className="mb-5 d-flex align-items-center justify-content-center">
            <button type='button' className="btn rounded-pill px-5" 
                  onClick={viewfile}
                  >
                     View Your File On IPFS
                     </button>
            </div>
           
       </div>
            </div>
            
       </div>    
            ):
            (
                <div className='startwritingcard'>
          
                <h1>SELECT BLOCKCHAIN</h1>
                <div className="container">
                    <form id='startWritingForm' ref={formref}>
                        <div className="radio-tile-group mb-4 mt-3">
                            <div className="input-container">
                                <input id="walk" className="radio-button" type="radio" name="radio" onChange={handleRadioChange} value='IPFS' />
                                <div className="radio-tile rounded-pill">
                                    
                                    <label htmlFor="walk" className="radio-tile-label px-2">IPFS</label>
                                </div>
                            </div>
    
                            <div className="input-container">
                                <input id="bike" className="radio-button" type="radio" name="radio" onChange={handleRadioChange} value='FileCoin' />
                                <div className="radio-tile rounded-pill">
                                   
                                    <label htmlFor="bike" className="radio-tile-label px-2">FileCoin</label>
                                </div>
                            </div>
    
                            <div className="input-container">
                                <input id="drive" className="radio-button" type="radio" name="radio" onChange={handleRadioChange} value='Arweave'/>
                                <div className="radio-tile rounded-pill">
                                   
                                    <label htmlFor="drive" className="radio-tile-label px-2">Arweave</label>
                                </div>
                            </div>
                        </div>
    
                        <div className="mb-4">
                            <label htmlFor="dao_name" className="form-label">Choose a file</label>
                            <input required style={{background:'hwb(186 24% 10%)',color:'black'}} type="file" className="form-control bg-yellow" id="dao_name" onChange={handleFileChange} />
                        </div>
                        <br />
                        <div className="mb-5">
                            <label htmlFor="s_wallet" className="form-label">File Name*
                                
                                
                            </label>
    
                            <input type="textarea" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="s_wallet" onChange={handlenameChange} required />
                            
                        </div>
                        <div className="mb-5">
                            <label htmlFor="s_wallet" className="form-label">Version Comments
                                
                                
                            </label>
    
                            <input type="textarea" style={{background:'hwb(186 24% 10%)',color:'black'}} className="form-control bg-yellow mb-3" id="s_wallet"  />
                            
                        </div>
                        
                        
                                
                        <div className="mb-4 d-flex align-items-center justify-content-center">
                                {/* <Link to={{
                                    pathname:'/WriteHere',
                                }}> */}
                                     <button type='button' className="btn rounded-pill px-5" 
                           onClick={uploadFileToIPFS}
                            >
                               Upload
                               </button>
                                
                                
                                
                            
                            <button type='button' className="btn rounded-pill px-5" 
                           onClick={cancel_upload}
                            >
                               Cancel
                               </button>
                                
                                
                                
                           
                                {/* </Link> */}
                           
                        </div> 
                                
                                
                                
                          
                       
                    </form>
    
    
                </div>
    
            </div >  
            )
        }
       
        </>
    )
    
}
// import React, { useState } from 'react';

// const UploadFileForm = () => {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploadedHash, setUploadedHash] = useState(null);

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     setSelectedFile(file);
//   };

//   const handleUpload = () => {
//     if (!selectedFile) {
//       console.error('No file selected');
//       return;
//     }

    // const formData = new FormData();
    // formData.append('file', selectedFile);

    // fetch('http://localhost:5001/api/v0/add', {
    //   method: 'POST',
    //   body: formData,
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     // Handle the response from IPFS
    //     console.log('File uploaded to IPFS:', data);
    //     setUploadedHash(data.Hash);
    //   })
    //   .catch((error) => {
    //     console.error('Failed to upload file to IPFS:', error);
    //   });
//   };

//   return (
//     <div>
//       <input type="file" onChange={handleFileChange} />
//       <button onClick={handleUpload}>Upload</button>
//       {uploadedHash && (
//         <div>
//           <p>File uploaded to IPFS:</p>
//           <p>Hash: {uploadedHash}</p>
//           <p>
//             View file on IPFS:{' '}
//             <a
//               href={`http://localhost:8080/ipfs/${uploadedHash}`}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               Link
//             </a>
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadFileForm;
